<template>
  <div
    class="row subMenuItem">
    <div class="col-12 text-left">
      <i
        v-if="icon !== ''"
        :class="icon"
        class="mr-2 icon"
        @click="go"/>
      <span
        class="name non-selectable-text"
        @click="go">
        <slot/>
      </span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SubMenuItem',
  components: {},
  props: {
    to: {
      type: String,
      default: null,
    },
    query: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: '',
    },
  },
  methods: {
    go() {
      if (this.to) {
        if (this.to.includes('http')) {
          window.open(this.to, '_blank');
        } else {
          this.$router.push(this.to + this.formatQuery(this.query));
        }
      }
      this.$emit('click');
    },
    formatQuery(q) {
      let formatedQuery = '';
      if (q) {
        formatedQuery = q.replace('{lang}', this.$i18n.locale);
      }
      return formatedQuery;
    },
  },
};
</script>

<style scoped lang="scss">
span {
  &.name {
    color: $primary;
    cursor: pointer;
  }
}
i {
  &.icon {
    cursor: pointer;
  }
}
</style>
